import React, { useEffect, useState } from 'react';
import { archivedClientsColumns } from '../Columns';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { fetchArchivedClients, resetClientsTableData } from '../../../redux/client/clientSlice';
import ClientTable from '../ClientTable';
import NoArchievedDataView from './NoArchievedDataView';
import { ClientsProps } from '../../../pages/Clients/Clients';
import { SubscriptionPlanTypes } from '../../../types/coach';

const ArchivedClients = ({
  pageSize,
  currentPage,
  skip,
  handleOnPaginationModelChange,
}: ClientsProps) => {
  const dispatch = useAppDispatch();
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [exisitingCoach, setExistingCoach] = useState<boolean>(false);
  const [initialRender, setInitialRender] = useState<boolean>(true);

  const coach = useAppSelector((state) => state.coach.coach);
  const { archivedClients, totalArchivedClientCount, fetchArchivedClientsLoading } = useAppSelector(
    (state) => state.client
  );

  const fetchClients = () => {
    if (coach) {
      const payload = {
        coachId: coach?.id,
        nameText: searchTerm,
        skip,
        take: pageSize,
        isArchived: true,
        orderBy: 'updatedAt',
        order: 'desc',
      };
      dispatch(fetchArchivedClients(payload));
    }
  };

  useEffect(() => {
    fetchClients();
  }, [coach.id, pageSize, currentPage]);

  useEffect(() => {
    fetchClients();
    setInitialRender(false);
  }, []);

  useEffect(() => {
    if (!initialRender) {
      const debounceSearch = setTimeout(() => {
        fetchClients();
      }, 1000);
      return () => clearTimeout(debounceSearch);
    }
  }, [searchTerm, dispatch]);

  const handleChangeSearchTerm = (newValue: string) => {
    setSearchTerm(newValue);
  };

  useEffect(() => {
    if (totalArchivedClientCount > 0 && !exisitingCoach) {
      setExistingCoach(true);
    }
  }, [totalArchivedClientCount, exisitingCoach]);

  useEffect(
    () => () => {
      dispatch(resetClientsTableData());
    },
    []
  );

  const subscriptionPlanStatus = useAppSelector(
    (state) => state.coach.coach.subscriptionPlanStatus
  );
  const { currentPlan, daysLeft } = subscriptionPlanStatus || {};
  const isFreeTrial = currentPlan === SubscriptionPlanTypes.FREE_TRIAL;
  const showBanner = () => {
    if (coach.isReadOnly) {
      return true;
    }
    return isFreeTrial && daysLeft !== undefined && daysLeft <= 10;
  };

  return !fetchArchivedClientsLoading && !exisitingCoach && totalArchivedClientCount === 0 ? (
    <NoArchievedDataView addExtraBottomMargin={showBanner()} />
  ) : (
    <ClientTable
      rows={!fetchArchivedClientsLoading ? archivedClients : []}
      rowCount={totalArchivedClientCount}
      loading={fetchArchivedClientsLoading}
      columns={archivedClientsColumns}
      handleOnPaginationModelChange={handleOnPaginationModelChange}
      handleOnChangeSearchTerm={handleChangeSearchTerm}
      searchTerm={searchTerm}
      pageSize={pageSize}
      page={currentPage}
      addExtraBottomMargin={showBanner()}
    />
  );
};

export default ArchivedClients;
